<template>
  <div>
    <label class="vs-input--label" v-if="label">{{ label }}</label>
    <vs-input
      v-model="dateValue"
      v-mask="'##/##/####'"
      maxlength="10"
      placeholder="DD/MM/AAAA"
      class="w-full"
      :name="name"
      :disabled="disabled"
      :state="state"
      :danger="danger"
      @input="validDate"
    />
  </div>
</template>

<script>
import dateConversion from '../utils/dateConversion';
import notify from '../utils/notify';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: null,
    },
    danger: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateValue: this.formatDate(this.value),
    };
  },
  watch: {
    value(newValue) {
      const formattedDate = this.formatDate(newValue);
      if (formattedDate !== this.dateValue) {
        this.dateValue = formattedDate;
      }
    },
    dateValue(newValue) {
      const formattedDate = this.formatDate(newValue);
      if (formattedDate !== this.value) {
        this.$emit('input', formattedDate);
      }
    },
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return '';
      }
      if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const parts = date.split('-');
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      return date;
    },
    validDate() {
      if (this.dateValue.length !== 10) {
        return;
      }

      const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;
      if (!regex.test(this.dateValue)) {
        notify.notifyFail(this.$vs, `${this.name} inválida. Insira uma data válida no formato DD/MM/AAAA`);
        this.dateValue = '';
        return;
      }

      const dateIsValid = dateConversion.dateIsValid(this.dateValue);
      if (!dateIsValid) {
        notify.notifyFail(this.$vs, `${this.name} inválida. Insira uma data válida.`);
        this.dateValue = '';
        return;
      }
    },
  },
};
</script>
